import { render } from "./AdminUsers.vue?vue&type=template&id=3eb19640"
import script from "./AdminUsers.vue?vue&type=script&lang=js"
export * from "./AdminUsers.vue?vue&type=script&lang=js"
script.render = render

export default script